import { faPlusCircle, faSearch } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import ReactTable from 'react-table-v6';
import 'react-table-v6/react-table.css';
import { Config } from '../../../../../shared/config';
import { onSelectUserViewAction } from '../../../../../stores/actions/userData';
import PageToggleButton from '../../../../Common/PageToggleButton';
import { Pagination } from '@mui/material';
import ViewCell from '../../../../Common/Table/ViewCell';
import './../../../modelListStyle.scss';
import modelService from './../../../modelService';


const filterArrRes = [];

class userList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            usersData: [],
            noRecordsMessage: null,
            showPagination: false,
            rowsPerPage: 10,
            page: 1,
            totalCount: 0,
            total: 0,
            filterInUse: false,
            filterArr: []
        };
        this.modelService = new modelService();
        this.tableList = React.createRef();
    }

    /**
     * Rendering ui elements
     */
    render() {
        const { usersData, noRecordsMessage, showPagination, totalCount, page, rowsPerPage ,filterInUse} = this.state;
        return (
            <div className="model-list-box">
                <div>
                    <Button className="add-usr-btn text-center btn-sm" onClick={this.addNewUser}>
                        <FontAwesomeIcon className="btn-icon" icon={faPlusCircle} />
                        <span className="ml-2">Add User</span>
                    </Button>
                </div>
                <div className="table-responsive-cm user-list-table" ref={this.tableList}>
                    <ReactTable
                        filterable
                        
                        defaultFilterMethod={(filter, row) =>
                            row[filter.id] !== undefined
                                ? String(row[filter.id]).toLowerCase().includes(filter.value.toLowerCase())
                                : false
                        }
                        columns={[
                            {
                                Header: 'Customer Name',
                                accessor: 'company',
                                Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'company'),
                            },
                            {
                                Header: 'Email Address',
                                accessor: 'emailAddress',
                                Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'emailAddress'),
                            },
                            
                            {
                                Header: 'Last Name',
                                accessor: 'lastName',
                                Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'lastName'),
                            },
                            {
                                Header: 'First Name',
                                accessor: 'firstName',
                                Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'firstName'),
                            },
                            
                            {
                                Header: 'Role',
                                accessor: 'userRole',
                                Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'userRole'),
                            },
                            {
                                Header: 'Status',
                                accessor: 'status',
                                Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'status'),
                            },
                            {
                                Header: 'Modified Date',
                                accessor: 'modifiedDate',
                                Cell: (props) => {
                                    const modifiedDate = props.value
                                        ? moment.utc(props.value, Config.UI_TIMESTAMP_FORMAT).local()
                                        : '';
                                    return props.value
                                        ? moment(modifiedDate, Config.API_TIMESTAMP_FORMAT).format(
                                              Config.UI_TIMESTAMP_FORMAT,
                                          )
                                        : '';
                                },
                                sortMethod: (a, b) => {
                                    var a1 = new Date(a).getTime();
                                    var b1 = new Date(b).getTime();
                                    if (a1 > b1) return 1;
                                    else if (a1 < b1) return -1;
                                    else return 0;
                                },
                                Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'modifiedDate'),
                            },
                            {
                                Header: 'Modified By',
                                accessor: 'modifiedBy',
                                Filter: ({filter, onChange}) => this.filterRender(filter, onChange, 'modifiedBy'),
                            },
                            {
                                Header: () => <div style={{ textAlign: 'center' }}>Action</div>,
                                Cell: ViewCell,
                                getProps: (state, rowInfo) => ({
                                    onClick: () => {
                                        this.userListViewClick(rowInfo);
                                    },
                                }),
                                className: 'td-button-outer',
                                minWidth: 110,
                                filterable: false,
                            },
                        ]}
                        data={usersData}
                        noDataText={noRecordsMessage}
                        minRows={usersData.length}
                        showPagination={showPagination}
                        pageSize={usersData.length}
                        className="-highlight cursor-pointer w-100"
                        style={
                            usersData.length >= 5
                                ? {
                                    height: 'calc(100vh - 290px)',
                                  }
                                : {}
                        }
                        defaultSorted={[{ id: 'modifiedDate', desc: true }]}
                    />
                </div>
                    <div className='pagination-div'>
                        <Pagination  showFirstButton showLastButton disabled = {filterInUse}
                            component="div"
                            count={totalCount}
                            page={page}
                            rowsPerPage={rowsPerPage}
                            onChange={this.handleChangePage}
                            variant="outlined"
                            shape="rounded"
                            sx={{
                                ".MuiPaginationItem-root": {
                                    fontSize: '16px',
                                    marginTop: '15px',
                                },
                                ".Mui-selected": {
                                    backgroundColor: '#135d87 !important',
                                    color:'#fff',
                                }
                            }}
                        />
                        <PageToggleButton rowsPerPageOptions={[10,20,50,100]} filterInUse = {filterInUse}
                                        perPageCount= {rowsPerPage}  
                                        rowsPerPage={(perPage) => {this.setState({rowsPerPage: perPage}); 
                                        this.onPageOrPageLoadChange(1, perPage)}}/>
                    </div>
                </div>    
        );
    }

    /**
     * Component mount method.
     */
    componentDidMount() {
        // Api call to get the user list.
      this.modelService.getUsersList().then((res) => {
            if (res && res.status === 'Success' && res.data) {
               const {
                totalPages,
                data,
                total
            } = paginateUI(res.data, 10, 1);
                this.setState({
                    usersData: data,
                    noRecordsMessage: null,
                    page: 1,
                    totalCount: totalPages,
                    total: total
                });
            } else {
                this.setState({
                    usersData: [],
                    noRecordsMessage: '-No Users Found-',
                });
            }
        });
    }

    /**
     * Add new user button click function.
     */
    addNewUser = () => {
        this.props.history.push('/model/admin/user');
    };

    /**
     * View user button click function.
     */
    userListViewClick(rowInfo) {
        this.props.setSelectedUser(rowInfo.original);
        this.props.history.push(`/model/admin/user/${rowInfo.original.userId}`);
    }

    async onPageOrPageLoadChange(newPage, perPage){
        this.modelService.getUsersList().then((res) => {
            if (res && res.status === 'Success' && res.data) {
                const { data, totalPages } =  paginateUI(res.data, perPage, newPage);
                if (data && data.length > 0 ) {
                    this.setState({
                        usersData: data,
                        noRecordsMessage: null,
                        totalCount: totalPages,
                        page: parseInt(newPage, 10),
                    });
                }
            } else {
                this.setState({
                    usersData: [],
                    noRecordsMessage: '-No Users Found-',
                });
            }
        });
    }

    handleChangePage = async (event, newPage) => {
        this.setState({page: newPage});
        this.modelService.getUsersList().then((res) => {
            if (res && res.status === 'Success' && res.data) {
                const {data} =  paginateUI(res.data, this.state.rowsPerPage, newPage);
                if (data && data.length > 0 ) {
                    this.setState({
                        usersData: data,
                        noRecordsMessage: null,
                    });
                }
            } else {
                this.setState({
                    usersData: [],
                    noRecordsMessage: '-No Users Found-',
                });
            }
        });
    };   

    onFilterRenderChange = async (event, field) => {
        const { usersData, total , rowsPerPage, page} = this.state;
        if(field){
            if (!event.target.value){
                 filterArrRes.pop(field);
            } else if(!filterArrRes.includes(field)){
                filterArrRes.push(field);
            } 
        }
        if(!event.target.value && filterArrRes.length == 0){
             const {data} = await paginateUI(usersData, rowsPerPage, page);
            if (data && data.length > 0 ) {
                this.setState({
                    usersData: data,
                    filterInUse: false
                });
            }
        } else if(usersData.length != total){
            this.modelService.getUsersList().then((res) => {
                if (res && res.status === 'Success' && res.data) {
                        this.setState({
                            usersData: res.data,
                            filterInUse: true 
                        });
                    }
            });
        } 
    }

    filterRender = (filter, onChange, field) => {
        return (
            <div style={{position: 'relative', backgroundColor: '#FFFFFF', paddingLeft: '10px'}}>
            <FontAwesomeIcon icon={faSearch} className='filter-search-icon' />
            <input
            onChange={event => { this.onFilterRenderChange(event, field) ; onChange(event.target.value);}}
            value={filter ? filter.value : ''}
            style={{
                width: '100%',
                border: '0px'
            }}
            />
        </div>
        )
    }
}

const paginateUI = (items, perPage, page) => {

    const offset = perPage * (page - 1);
    const totalPages = Math.ceil(items.length / perPage);
    const paginatedItems = items.slice(offset, perPage * page);
      
    return {
        previousPage: page - 1 ? page - 1 : null,
        nextPage: (totalPages > page) ? page + 1 : null,
        total: items.length,
        totalPages: totalPages,
        data: paginatedItems
    };
   
};

/**
 * Redux dipatch events method for changing redux state
 */
const MapDispatchToProps = (dispatch) => {
    return {
        setSelectedUser: (params) => dispatch(onSelectUserViewAction(params)),
    };
};


userList.propTypes = {
    history: PropTypes.object.isRequired,
    setSelectedUser: PropTypes.func,
};

export default withRouter(connect(null, MapDispatchToProps)(userList));